module.exports = __webpack_public_path__ + "img/blis4.dbb8727a.png";